import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=547b3c92"
import script from "./snapshot.vue?vue&type=script&lang=js"
export * from "./snapshot.vue?vue&type=script&lang=js"
import style0 from "./snapshot.vue?vue&type=style&index=0&id=547b3c92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports